import { Fragment, ReactElement } from 'react';
import PersonSearchMarriageNonResidentNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-marriage-non-resident/edit-person-search';
import { IdAmbito } from 'shell/constants/id-ambito';

const PersonSearchMarriageNonResidentNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonSearchMarriageNonResidentNotificationsCivilStatusShared
        scope={IdAmbito.Cancellazioni}
      />
    </Fragment>
  );
};

PersonSearchMarriageNonResidentNotificationsCivilStatusPage.displayName =
  'Research Marriage Non Resident Notifications CivilStatusPage component';

export default PersonSearchMarriageNonResidentNotificationsCivilStatusPage;
